import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { WhyFailed } from './components/WhyFailed';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoFor } from './components/WhoFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '1526250942551872';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
    __mpPageViewFired?: boolean;
  }
}
export function App() {
  useEffect(() => {
    // ============================================
    // SEO META TAGS
    // ============================================
    const pageTitle = 'The 48-Hour Airbnb Cleanup Protocol | 5-Star Turnover in 120 Minutes';
    document.title = pageTitle;
    const metaDescription = 'The step-by-step emergency cleaning system for solo Airbnb hosts. Finish a 5-star turnover in under 120 minutes — even alone. Instant PDF download for $6.36.';
    const setMetaTag = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.querySelector(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMetaTag('name', 'title', pageTitle);
    setMetaTag('name', 'description', metaDescription);
    setMetaTag('name', 'keywords', 'Airbnb cleaning checklist, Airbnb turnover protocol, short-term rental cleaning, Superhost cleaning guide, Airbnb cleaning system, vacation rental cleaning PDF');
    setMetaTag('property', 'og:type', 'website');
    setMetaTag('property', 'og:title', pageTitle);
    setMetaTag('property', 'og:description', metaDescription);
    setMetaTag('property', 'og:image', 'https://cdn.magicpatterns.com/uploads/6zswByJzs2XWdCc2bmvTJD/heylloyd-image-1778928817369.png');
    setMetaTag('name', 'twitter:card', 'summary_large_image');
    setMetaTag('name', 'twitter:title', pageTitle);
    setMetaTag('name', 'twitter:description', metaDescription);
    setMetaTag('name', 'twitter:image', 'https://cdn.magicpatterns.com/uploads/6zswByJzs2XWdCc2bmvTJD/heylloyd-image-1778928817369.png');
    // ============================================
    // META PIXEL (FACEBOOK PIXEL)
    // ============================================
    // Guard: only fire PageView once per page load. Prevents React
    // StrictMode double-invocation and re-mounts from duplicating events.
    if (window.__mpPageViewFired) return;
    window.__mpPageViewFired = true;
    // Set up the fbq stub if it doesn't already exist.
    if (!window.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window.fbq = n;
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Append fbevents.js directly to <head>. The original FB snippet
      // uses document.getElementsByTagName('script')[0].parentNode, which
      // throws "Cannot read properties of undefined (parentNode)" in
      // bundled React apps where no <script> tag is present at runtime.
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    // Disable Meta's automatic PageView on init, so it only fires once
    // from our explicit track() call below (avoids duplicate events).
    window.fbq('set', 'autoConfig', false, META_PIXEL_ID);
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-dark selection:bg-brand-yellow selection:text-brand-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <WhyFailed data-id="element-3" />
      <Mechanism data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <WhoFor data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <Proof data-id="element-8" />
      <FAQ data-id="element-9" />
      <Offer data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}